/* eslint-disable jsx-a11y/iframe-has-title */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react';
import Nav from '../components/layout/Nav';
import Footer from '../components/layout/Footer';
import '../styles/contact.scss';
import { FaFacebookF } from 'react-icons/fa';
import { FaInstagram } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';
import { FaPhoneAlt } from 'react-icons/fa';
import { MdEmail } from 'react-icons/md';
import { FaLocationDot } from 'react-icons/fa6';
const Contact = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    phone: '',
    email: '',
    message: '',
    acceptTerms: false,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    alert('Form submitted successfully!');
    setFormData({
      firstName: '',
      lastName: '',
      phone: '',
      email: '',
      message: '',
      acceptTerms: false,
    });
  };

  return (
    <div>
      <Nav />

      {/* Hero Section */}
      <section className="contact-page-hero">
        <div className="contact-page-hero-content">
          <h1>Contact Us</h1>
          <h6>
            <a href="/">Home</a> - Contact us
          </h6>
        </div>
      </section>

      {/* Contact Section */}
      <section className="get-in-touch">
        <div className="contact-flex-container">
          <div className="contact-info">
            <div className="contact-item">
              <h2 className="section-title">Get In Touch With Us</h2>
            </div>

            {/* Phone Numbers */}
            <div className="contact-item">
              <div className="info-content">
                <div className="icon-wrapper">
                  <FaPhoneAlt />
                </div>
                <div className="text-wrapper">
                  <h4>Contact Us</h4>
                  <p>+01234-567890</p>
                  <p>+01234-5688765</p>
                </div>
              </div>
            </div>

            {/* Email Address */}
            <div className="contact-item">
              <div className="info-content">
                <div className="icon-wrapper">
                  <MdEmail />
                </div>
                <div className="text-wrapper">
                  <h4>Email Address</h4>
                  <p>
                    <a href="mailto:artizakenya@gmail.com">
                      artizakenya@gmail.com
                    </a>
                  </p>
                  {/* <p>info@example.com</p> */}
                </div>
              </div>
            </div>

            {/* Office Location */}
            <div className="contact-item">
              <div className="info-content">
                <div className="icon-wrapper">
                  <FaLocationDot />
                </div>
                <div className="text-wrapper">
                  <h4>Office Location</h4>
                  <p>
                    123 Street New York City, United States Of America NY
                    750065.
                  </p>
                </div>
              </div>
            </div>

            {/* Follow Us */}
            <div className="contact-item follow-us">
              <h4>Follow Us</h4>
              <div className="social-icons">
                <a href="#" className="social-icon">
                  <FaFacebookF />
                </a>
                <a href="#" className="social-icon">
                  <FaXTwitter />
                </a>
                <a href="#" className="social-icon">
                  <FaInstagram />
                </a>
              </div>
            </div>
          </div>

          {/* Right Column - Contact Form */}
          <form className="contact-form" onSubmit={handleSubmit}>
            {/* First Name & Last Name in one row */}
            <div className="form-field-group">
              <div className="form-group form-group-half">
                <label htmlFor="firstName">First Name *</label>
                <input
                  type="text"
                  id="firstName"
                  name="firstName"
                  placeholder="Your First Name" // Simple placeholder for context
                  value={formData.firstName}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group form-group-half">
                <label htmlFor="lastName">Last Name *</label>
                <input
                  type="text"
                  id="lastName"
                  name="lastName"
                  placeholder="Your Last Name" // Simple placeholder for context
                  value={formData.lastName}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            {/* Phone & Email in one row */}
            <div className="form-field-group">
              <div className="form-group form-group-half">
                <label htmlFor="phone">Phone Number *</label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  placeholder="Phone number"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group form-group-half">
                <label htmlFor="email">Email *</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  placeholder="Email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            {/* Message Area */}
            <div className="form-group">
              <label htmlFor="message">Write Your Message *</label>
              <textarea
                id="message"
                name="message"
                placeholder="Write Your Message"
                rows="5"
                value={formData.message}
                onChange={handleChange}
                required
              ></textarea>
            </div>

            {/* Terms Checkbox */}
            {/* <div className="form-group terms-group">
                <input
                    type="checkbox"
                    id="acceptTerms"
                    name="acceptTerms"
                    checked={formData.acceptTerms}
                    onChange={handleChange}
                    required
                />
                <label htmlFor="acceptTerms">Accept Terms & Condition</label>
            </div> */}

            {/* Submit Button */}
            <button type="submit" className="submit-btn">
              Submit Now
            </button>
          </form>
        </div>
      </section>
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14438.014278827262!2d36.74962565!3d-1.39766815!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x182f05c52ffa57e1%3A0xbc9dfefe6d0aaad6!2sThe%20Siron%20Place%20Hotel!5e1!3m2!1sen!2ske!4v1761069202613!5m2!1sen!2ske"
        height="600"
        style={{ border: 0 }}
        allowfullscreen=""
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"
      ></iframe>

      <Footer />
    </div>
  );
};

export default Contact;
